import { gql } from "@apollo/client";

export const GET_MY_DRIVER_ROUTE_START_END_POINT = gql`
    query GetMyDriverRouteStartEndPoint {
        getMyDriverRouteStartEndPoint {
            id
            accountId
            start {
                country
                state
                city
                district
                detailAddress
                latitude
                longitude
                standardizedAddress
            }
            end {
                country
                state
                city
                district
                detailAddress
                latitude
                longitude
                standardizedAddress
            }
        }
    }
`;

export interface DriverRouteEndPointAddressResponse {
    country: string;
    state: string;
    city: string;
    district?: string | null;
    detailAddress: string;
    latitude?: number | null;
    longitude?: number | null;
    standardizedAddress?: string | null;
}

export interface DriverRouteStartEndPointResponseData {
    id: string | number;
    accountId: string | number;
    start: DriverRouteEndPointAddressResponse;
    end: DriverRouteEndPointAddressResponse;
}

export interface GetMyDriverRouteStartEndPointResponse {
    getMyDriverRouteStartEndPoint: DriverRouteStartEndPointResponseData | null;
}
